import List from '../views/users/List'

export default [
    {
        path: '/admin/users',
        name: 'users',
        component: List,
    },
]
